import { axiosInstance } from "@/lib/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from '@/hooks/use-toast';
import type {User} from '@/types/User';


const userAdd = async (velId, body: Partial<User>) => {
  const { data } = await axiosInstance.post(
    `/api/abo/vel/${velId}/user`, body
  );
  return data;
};

export const useUserAdd = ({velId}) => {
  const {toast} = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: Partial<User>) =>
      userAdd(velId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['vel', velId, 'users'],
      });
      toast({
        variant: "default",
        title: "L'utilisateur a été ajouté",
      });
    },
    onError: () => {
      toast({
        title: "Il y a un problème",
        variant: "destructive",
      });
    },
  });
};
